import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconChartBars12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconChartBars12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 9a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 1 0v7a.5.5 0 0 1-.5.5M3 8.5v-3a.5.5 0 0 0-1 0v3a.5.5 0 0 0 1 0M.5 10a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zM6 8.5a.5.5 0 0 0 1 0v-5a.5.5 0 0 0-1 0zm-1-1v1a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 1 0m3 1a.5.5 0 0 0 1 0V5a.5.5 0 0 0-1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconChartBars12);
